module.exports = __webpack_public_path__ + "static/media/AoA_HomeSections_RaceGame.f1e2be79.jpg";